// src\layouts\MainLayout.tsx
import React from "react";
import { Box, Toolbar, AppBar, IconButton, Avatar } from "@mui/material";
import Sidebar from "./Sidebar";
// import logo from "../assets/images/logo.png";
import { Link } from "react-router-dom";
import Scss from "./MainLayout.module.scss";

const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Box sx={{ display: "flex" }}>
      <Sidebar />
      <Box
        sx={{
          flexGrow: 1,
          minHeight: "100vh",
          backgroundColor: "#DBDBDB",
          boxSizing: "border-box",
          overflow: "auto",
          p: 0,
        }}
      >
        {/* innerBoxを追加してpadding等はここで管理する */}
        <Box sx={{ width: "100%", maxWidth: "100%" }}>{children}</Box>
      </Box>
    </Box>
  );
};

export default MainLayout;
